import request from "@/utils/request";

export function getFeedBackMsg() {
  return request({
    url: "/api/FeedBack/IsShowFeeBackMsg",
    method: "post",
  });
}

export function GetFeeBackType() {
  return request({
    url: "/api/FeedBack/GetFeeBackType",
    method: "post",
  });
}

export function addFeedback(param) {
  return request({
    url: "/api/FeedBack/Add",
    method: "post",
    data: param,
  });
}

export function editFeedback(param) {
  return request({
    url: "/api/FeedBack/Edit",
    method: "post",
    data: param,
  });
}

export function getFeedbackList(param) {
  return request({
    url: "/api/FeedBack/List",
    method: "post",
    data: param,
  });
}

export function getFeedbackById(id) {
  return request({
    url: `/api/FeedBack/Get?id=${id}`,
    method: "post",
  });
}

export function replyAdd(FeedBackId, Remark) {
  return request({
    url: `/api/FeedBack/ReplyAdd?FeedBackId=${FeedBackId}&Remark=${encodeURIComponent(Remark || "")}`,
    method: "post",
  });
}

export function getReplyList(FeedBackId) {
  return request({
    url: `/api/FeedBack/GetReplyList?FeedBackId=${FeedBackId}`,
    method: "post",
  });
}

export function feedBackRightRemaining() {
  return request({
    url: "/api/FeedBack/FeedBackRightRemaining",
    method: "post",
  });
}

/** Normalize GetFeeBackType items → { label, value, disabled } */
export function normalizeFeeBackTypes(body) {
  if (!Array.isArray(body)) return [];
  return body.map((item) => {
    const obj = {};
    Object.keys(item || {}).forEach((key) => {
      const val = key.replace(key[0], key[0].toLowerCase());
      obj[val] = item[key];
    });
    return {
      label: obj.text,
      value: obj.value,
      disabled: !!obj.disabled,
      raw: obj,
    };
  });
}
